<div class="p-form-layout01">
  <div class="p-form-layout01__item" style="padding-top: 0px">
    <div class="p-terms-conditions p-agreement-container--selected u-mt-pc-30">
      <div class="p-terms-conditions__body">
        <h2
          *ngIf="siteSwitchTitleKey"
          class="p-terms-conditions__title c-text-m c-text-m--bold"
          [innerHTML]="siteSwitchTitleKey | staticMsg"
        ></h2>
        <nav class="p-terms-conditions__contents">
          <ul class="p-terms-conditions__list">
            <li
              *ngIf="siteSwitchGuidanceKey"
              class="p-terms-conditions__list-item"
              style="font-size: 1.4rem"
              [innerHTML]="siteSwitchGuidanceKey | staticMsg"
            ></li>
          </ul>
        </nav>
      </div>
      <div class="p-terms-conditions__foot">
        <div class="p-terms-conditions__foot-agree">
          <asw-checkbox
            required
            id="agreement-checkBox1"
            [label]="'m_static_message-label.agreementRules' | staticMsg"
            (change$)="clickAgreeChecked($event)"
          ></asw-checkbox>
        </div>
      </div>
    </div>
    <div *ngIf="isChangeLang">
      <br />
      <h2
        class="c-message-box__title c-message-box__title--em"
        [innerHTML]="'m_static_message-label.displayLanguage' | staticMsg"
      ></h2>
      <br />
      <p
        class="c-message-box__contents"
        [innerHTML]="'m_static_message-label.selectLanguage.siteRedirection' | staticMsg"
      ></p>
      <br />
      <div class="p-input-block01__row-body">
        <div class="p-input-block01__row-body-item">
          <asw-radio-group
            id="agreement-radio-group1"
            name="selectLanguage"
            [formControl]="langCodeFc"
            direction="sp-vertical"
          >
            <asw-radio-button
              *ngFor="let item of langList; index as i"
              id="agreement-radio-item-{{ i }}"
              value="{{ item.code }}"
              label="{{ item.disp }}"
            ></asw-radio-button>
          </asw-radio-group>
        </div>
      </div>
    </div>
  </div>
</div>
